import React, { Component } from 'react';

import {
  Container
} from 'reactstrap';


class SmartPageContainer extends Component {
  
  render() {
    return (
      <Container className="smartpage-container">
        {this.props.children}
      </Container>
    );
  }
}


export default SmartPageContainer;


// WEBPACK FOOTER //
// ./src/containers/SmartPageContainer.js